import { IS_POST_NOTE_QUALITY_PANEL_ENABLED } from '@/app-shell/flags/growth-flags';
import { invalidateGamifyTrialExtension } from '@/hooks/query/useQueryGamifyTrialExtension';
import { usePostNoteQualityAnalytics } from '@/models/analytics/features/use-post-note-quality-analytics';

import { configurePostNoteQualityPorts } from '@heidi/growth/data';

configurePostNoteQualityPorts({
  isPanelEnabled: () => IS_POST_NOTE_QUALITY_PANEL_ENABLED(),
  invalidateGamifyTrialExtension: () => invalidateGamifyTrialExtension(),
  usePostNoteQualityAnalytics: () => usePostNoteQualityAnalytics(),
});
